import React from 'react';
import * as ReactDOM from 'react-dom';
import { TkGrid } from './components/TkGrid';
import './css/index.css';

ReactDOM.render(<TkGrid />, document.getElementById('root') as HTMLElement);
